import { el } from './dom.js';

/**
 * Placeholder animati mostrati durante il caricamento.
 * Riservano lo spazio delle card in arrivo, evitando che la pagina "salti".
 */

/**
 * @param {HTMLElement|null} container
 * @param {number} [count=10] quante card fantasma disegnare
 */
export function renderSkeleton(container, count = 10) {
  if (!container) return;
  container.replaceChildren(
    ...Array.from({ length: count }, () => el('div', { class: 'skeleton-card' })),
  );
}
